import { Pipe, PipeTransform } from '@angular/core';
import { isSameDay } from '@libs/utils';

@Pipe({
  name: 'dateEquals',
  standalone: true,
})
export class DateEqualsPipe implements PipeTransform {
  public transform(value: Date | string, dateExpression: 'today' | 'yesterday'): boolean {
    return dateExpression === 'today' ? this.isToday(value) : this.isYesterday(value);
  }

  private isToday(value: Date | string): boolean {
    return isSameDay(new Date(), new Date(value));
  }

  private isYesterday(value: Date | string): boolean {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return isSameDay(yesterday, new Date(value));
  }
}
